import { nullable, struct } from 'io-ts/Decoder';

import { Area } from '../../ui/geometry/Area';

import { Parameter } from './Parameter';

export const HVAC = struct({
	area: nullable(Area),
	height: nullable(Parameter),
});
